import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import azTranslation from "./locales/az/translation.json";
import enTranslation from "./locales/en/translation.json";
import ruTranslation from "./locales/ru/translation.json";

const resources = {
  az: { translation: azTranslation },
  en: { translation: enTranslation },
  ru: { translation: ruTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["en", "az", "ru"],
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["cookie", "localStorage"],
      caches: ["cookie"],
      lookupCookie: "lux_admin_lang",
      cookieMinutes: 525600, // 1 year
    },
  });

export default i18n;
